import React from 'react';
import { useSelector } from 'react-redux';
import HeaderIconButton from "./HeaderIconButton";

const HeaderCartButton = (props) => {
    let { quantity } = useSelector((state) => state.cart);
    return <HeaderIconButton {...props} number={quantity} hideNumber={props.hideNumber} />
};

export default HeaderCartButton;
